export default {
  refresh: 'Odśwież PDF',
  refreshHint: 'Tworzy raport ponownie z bieżącym szablonem i zastępuje zapisany raport dla wszystkich.',
  longRunning: {
    summary: 'Tworzenie raportu z audytu',
    detail: 'Tworzenie raportu może chwilę potrwać. Pozostaw to okno otwarte. Ten komunikat zamknie się, gdy rozpocznie się pobieranie.',
  },
};
